import { css } from 'styled-components';
import { CFBaseToggleTokens } from './styles';
export const CFBaseSwitchStyles = {
    InputWeb: css `
    margin: 0;
    appearance: none;
  `,
    Root: css `
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    gap: 0;
  `,
    SVGContainer: css `
    width: ${CFBaseToggleTokens.SWITCH.CONTAINER_WIDTH}px;
    height: ${CFBaseToggleTokens.SWITCH.CONTAINER_HEIGHT}px;
  `,
    SVGContainerWeb: css `
    g {
      transition-duration: 0.2s;
      transition-timing-function: ease-in-out;
      transition-property: transform, opacity;
    }

    rect {
      transition-duration: 0.2s;
      transition-timing-function: ease-in-out;
      transition-property: fill;
    }
  `,
};
export const CFBaseSwitchSVG = {
    Background: {
        height: 26,
        rx: 13,
        strokeWidth: 1,
        width: 44,
        x: 2,
        y: 1,
    },
    Check: {
        d: 'M10.575 16a.667.667 0 0 1-.486-.21l-3.241-3.453a.666.666 0 1 1 .97-.912l2.75 2.927 5.606-6.135a.667.667 0 0 1 .985.899l-6.091 6.667a.665.665 0 0 1-.488.217h-.005Z',
    },
    Switch: {
        cx: 12,
        cy: 12,
        r: 12,
    },
    Viewbox: {
        fill: 'none',
        viewBox: '0 0 48 28',
    },
};
